import React from 'react'
import SalesAdmin_PartnerListComponent from '../Components/PartnerList/SalesAdmin_PartnerListComponent'

function SalesAdmin_PartnerListPage() {
    return (
        <SalesAdmin_PartnerListComponent/>
    )
}

export default SalesAdmin_PartnerListPage